export const STATE_LABELS = {
  live: 'Reporting',
  late: 'Late',
  silent: 'Not reporting'
};
